<script>

export default {
    name: "InputSlider",

    props : {
        start : {
            type: Number,
            required: true,
        },
        min : {
            type: Number,
            required: true,
        },
        max: {
            type: Number,
            required: true,
        },
        step: {
            type: Number,
            default: 1,
        },
        label: {
            type: String,
            required: true,
        },
        attr: {
            type: String,
            required: true,
        },
        callback: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: 0
        },
    },

    computed :
    {
        isDisabled()
        {
            return (this.disabled == "1");
        }
    },

    data: function()
    {
        return {
            range : null,
        }
    },

    created ()
    {
        this.range = this.start;

        setTimeout(this.setSlider, 1000);
    },

    watch:
    {
        max() {
            this.setSlider();
        },
    },

    methods:
    {
        sliderChanged() {
            this.setSlider();
            this.$emit(this.callback, this.range);
        },

        setSlider() {
            const el = document.getElementById(this.attr);

            const min = this.min;
            const max = this.max;
            const val = this.range;

            el.style.backgroundSize = (val - min) * 100 / (max - min) + '% 100%';
        }
    },
}
</script>

<template>
    <div class="input-slider">
        <label for="attr" class="d-none">{{ label }}</label>
        <input type="range"
               v-model="range"
               :id="attr"
               :min="min"
               :max="max"
               :disabled="isDisabled"
               class="form-slider"
               :step="step"
               @input="sliderChanged" />
    </div>
</template>